<template>
  <div>
    <div v-show="isShowModal">
      <div class="popup-overlay-bg"></div>
      <div class="popup-modal">
        <div class="popup-overlay"></div>
        <img
          class="popup-close"
          @click="close"
          src="@/assets/icons/close-white.svg"
          alt=""
        />
        <div class="popup-body">
          <h2 class="popup-description">
            Receba todas as Novidades de Lançamento!
          </h2>
          <input
            class="popup-input"
            type="email"
            v-model="form.email"
            placeholder="DIGITE SEU EMAIL"
          />
          <button @click="sendNews" class="popup-button">
            {{ buttonText }}
          </button>
          <img
            class="popup-logo"
            src="@/assets/icons/header-logo.png"
            alt="logo site"
          />
        </div>
      </div>
    </div>
    <div class="modal-msg" :class="{ show: showConfirm }">
      <p class="message">{{ msg }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Popup",
  props: ["visible"],
  data() {
    return {
      buttonText: "Cadastre",
      form: {
        nome: "Cadastro via Popup",
        email: "",
      },
      showConfirm: false,
      msg: "",
      isShowModal: true,
    };
  },
  methods: {
    close(e) {
      e.preventDefault();
      this.isShowModal = false;
      sessionStorage.setItem("alreadyShow", "already shown");
    },
    sendNews(e) {
      e.preventDefault();
      this.buttonText = "Cadastrando...";
      this.showConfirm = true;
      axios
        .post("/newsletter", this.form)
        .then(() => {
          this.buttonText = "Cadastre";
          this.showConfirm = true;
          this.msg = "Seu e-mail foi adicionado a nosso cadastro.";
          this.isShowModal = false;
          setTimeout(() => {
            this.showConfirm = false;
            this.$router.push("/").catch(() => {});
            this.form.email = "";
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          }, 2000);
        })
        .catch(() => {
          this.buttonText = "Enviar";
          this.showConfirm = true;
          this.msg = "Houve um erro ao adicionar o e-mail.";
          setTimeout(() => {
            this.showConfirm = false;
          }, 2000);
        });
    },
  },
  mounted() {
    if (sessionStorage.getItem("alreadyShow")) {
      this.isShowModal = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.popup-overlay {
  width: 100%;
  height: 100%;
  background-color: #1d1d1d76;
  position: fixed;
  overflow: hidden;
  z-index: -1;
  top: 0;
  border-radius: 8px;
  left: 0;
}
.popup-overlay-bg {
  width: 100%;
  height: 100vh;
  background-color: #1d1d1d76;
  position: fixed;
  overflow: hidden;
  z-index: 20;
  top: 0;
  left: 0;
}
.popup-modal {
  position: fixed;
  width: 30%;
  height: 50%;
  top: 50%;
  left: 50%;
  right: 0;
  bottom: 0;
  z-index: 21;
  border-radius: 8px;
  transform: translate(-50%, -50%);
  background-image: url("../../assets/img/bg-popup.jpeg");
  background-size: cover;
  background-repeat: no-repeat;
  padding: 20px 30px;
  .popup-close {
    position: absolute;
    top: 5px;
    z-index: 23;
    right: 10px;
    cursor: pointer;
    padding: 5px;
    width: 25px;
  }
  .popup-body {
    margin-top: 15px;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 100%;
    .popup-description {
      padding: 15px;
    }
    .popup-input {
      margin-top: 20px;
      width: 80%;
      padding: 20px;
      border-radius: 6px;
      border: unset;
      &::placeholder {
        text-align: center;
        font-size: 16;
        color: #1d1d1d;
        font-weight: 500;
      }
    }
    .popup-button {
      margin-top: 20px;
      width: 80%;
      padding: 15px;
      border-radius: 6px;
      font-size: 25px;
      color: #fff;
      cursor: pointer;
      background-color: #1d1d1d;
    }
    .popup-logo {
      margin-top: 20px;
    }
  }
}
@media (max-width: 1440px) {
  .popup-modal {
    width: 40%;
    height: 50%;
  }
}
@media (max-width: 1024px) {
  .popup-modal {
    width: 50%;
    height: 60%;
  }
}
@media (max-width: 768px) {
  .popup-modal {
    width: 80%;
    height: 70%;
  }
}
@media (max-width: 500px) {
  .popup-modal {
    width: 90%;
    height: 40%;
    .popup-body {
      .popup-description {
        font-size: 16px;
      }
      .popup-input {
        padding: 15px;
      }
      .popup-button {
        padding: 10px;
        font-size: 20px;
      }
    }
  }
}
.modal-msg {
  width: 300px;
  height: 60px;
  z-index: 50;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
  position: fixed;
  font-size: 0.875rem;
  justify-content: center;
  align-items: center;
  top: 15%;
  z-index: 1000;
  background: #1d1d1d;
  display: none;
  left: 50%;
  transition: all 0.3s;
}

.message {
  text-align: center;
  color: #fff;
}

.show {
  animation: show 0.3s forwards;
  display: flex;
  opacity: 1;
  z-index: 1000;
}

@keyframes show {
  from {
    display: none;
    transform: translate3d(-50%, -10%, 0);
    opacity: 0;
  }
  to {
    display: flex;
    transform: translate3d(-50%, -15%, 0);
    opacity: 1;
  }
}
</style>
